import { render, staticRenderFns } from "./ProfileChangePasswordDialog.vue?vue&type=template&id=465dcb1c"
import script from "./ProfileChangePasswordDialog.vue?vue&type=script&lang=js"
export * from "./ProfileChangePasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports